import { render, staticRenderFns } from "./ReturnDoctor.vue?vue&type=template&id=230c683c&"
import script from "./ReturnDoctor.vue?vue&type=script&lang=js&"
export * from "./ReturnDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports